import { CssBaseline as MedlyCSSBaseline, ToastContainer } from '@medly-components/core';
import { useEffect, type FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { ErrorBoundary } from 'components';
import { CSSBaseline } from 'components/common';
import Routes from 'routes';
import { defaultTheme } from 'theme';

import { WithSwrConfig } from 'WithSwrConfig';
import { UserContextProvider } from './context/UserContext';
import './editor-styles.css';
import { MapTourContextProvider } from 'context/MapTourContext';
import { useReferrer } from 'hooks/useReferrer/useReferrer';

const App: FC = () => {
    const { setInitialReferrer } = useReferrer();

    useEffect(() => {
        setInitialReferrer();
    }, []);

    return (
        <ThemeProvider theme={defaultTheme}>
            <UserContextProvider>
                <MapTourContextProvider>
                    <MedlyCSSBaseline />
                    <CSSBaseline />
                    <Router>
                        <ErrorBoundary>
                            <ToastContainer style={{ maxWidth: '48rem' }} position="top-end" />
                            <WithSwrConfig>
                                <Routes />
                            </WithSwrConfig>
                        </ErrorBoundary>
                    </Router>
                </MapTourContextProvider>
            </UserContextProvider>
        </ThemeProvider>
    );
};

export default App;
